import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefHerdDetails, setBeefHerdDetailsAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_HERD_DETAILS } from "consts";

import { FootprintingBeefHerdDetails } from "models";

export const useMutateFootprintingBeefHerdDetails = (primaryDataId: string, farmId: string, year: number, data: Omit<FootprintingBeefHerdDetails, "id">) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<FootprintingBeefHerdDetails, Error, void>({
    mutationKey: [FOOTPRINTING_BEEF_HERD_DETAILS, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setBeefHerdDetailsAdmin(primaryDataId, data) : setBeefHerdDetails(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_BEEF_HERD_DETAILS, primaryDataId, isAdmin],
        ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
